<div class="breadcrumb-container" #breadcrumbContainer>
  @for (item of breadcrumb(); track item; let i = $index) {
    <span class="breadcrumb" (click)="navigateBreadcrumb(item)" [class.active]="item.area == floorplans().selectedArea">
      @if (i !== 0) {
        <cue-icon [icon]="cueArrowRight" />
      }
      <span class="part">{{ item.name }}</span>
    </span>
  }
</div>
<div class="map-container">
  <div class="map-frame">
    <div #mapElement style="height: 100%"></div>
    @if (mapRendering()) {
      <div class="map-loading-overlay">
        <cue-loading />
      </div>
    }
  </div>
</div>
